import api from '@/api/api'
import { Atendimento } from '../../../models/Atendimento'
import rules from '@/utils/formRules'
import Swal from 'sweetalert2'
import { getField, updateField } from 'vuex-map-fields'
import { v4 as uuid } from 'uuid'
import moment from 'moment'

export const BOOTSTRAP_PROFILE = 'BOOTSTRAP_PROFILE'
export const SUBMIT = 'SUBMIT'
export const SET_STATE = 'SET_STATE'
export const CLOSE = 'CLOSE'
export const RESET_STATE = 'RESET_STATE'
export const LOAD_PRODUTOS = 'LOAD_PRODUTOS'
export const LOAD_CATEGORIES = 'LOAD_CATEGORIES'
export const LOAD_UNIDADES = 'LOAD_UNIDADES'
export const PUSH_ITEM = 'PUSH_ITEM'
export const LOAD_PRODUTOS_UNIDADES = 'LOAD_PRODUTOS_UNIDADES'
export const DELETE_ITEM = 'DELETE_ITEM'
export const DELETE_SUBMIT = 'DELETE_SUBMIT'
export const LOAD_PRODUTOS_FROM_CATEGORY = 'LOAD_PRODUTOS_FROM_CATEGORY'
export const CREATE_ATENDIMENTO = 'CREATE_ATENDIMENTO'
export const LOAD_SERVICOS_UNIDADES = 'LOAD_SERVICOS_UNIDADES'
export const LOAD_SERVICOS = 'LOAD_SERVICOS'
export const LOAD_TECNICOS = 'LOAD_TECNICOS'
export const PUSH_ITEM_SERVICO = 'PUSH_ITEM_SERVICO'
export const DELETE_ITEM_SERVICO = 'DELETE_ITEM_SERVICO'
export const LOAD_PLANOS_PAGAMENTO = 'LOAD_PLANOS_PAGAMENTO'
export const SET_TABELA_PLANO_PAGAMENTO = 'SET_TABELA_PLANO_PAGAMENTO'
export const LOAD_SETOR_TECNICO = 'LOAD_SETOR_TECNICO'

const getDefaultState = () => {
  return {
    dialog: false,
    loading: true,
    rules,
    produtos: [],
    categorias: [],
    unidades: [],
    produtosUnidades: [],
    servicosUnidades: [],
    servicos: [],
    tecnicos: [],
    planos_pagamentos: [],
    tabela_plano_pagamento: null,
    setores_tecnico: [],
    desabilitarBotao: false,
  }
}

const state = getDefaultState()

const getters = {
  getField,
}

const mutations = {
  updateField,
  [RESET_STATE] (state) {
    Object.assign(state, getDefaultState())
  },
  [SET_STATE] (state, payload) {
    Object.assign(state, payload)
  },
  [CLOSE] (state) {
    state.dialog = false
  },

}

const actions = {
  [SET_TABELA_PLANO_PAGAMENTO] ({ commit }, tabela) {
    commit(SET_STATE, { tabela_plano_pagamento: tabela })
  },
  async [BOOTSTRAP_PROFILE] ({ dispatch, commit, state }, { atendimento }) {
    commit(RESET_STATE)
    commit(SET_STATE, { loading: true, dialog: true })
    await Promise.all([
      dispatch(LOAD_CATEGORIES),
      dispatch(LOAD_PRODUTOS),
      dispatch(LOAD_SERVICOS),
      dispatch(LOAD_TECNICOS),
      dispatch(LOAD_PLANOS_PAGAMENTO),
    ])
    if (atendimento) {
      await api.getEntidade('atendimento', atendimento.id).then(response => {
        const atendimento = response.data
        atendimento.itens.forEach(item => {
          item.nome_produto = item.produto.nome
        })
        atendimento.itens_servicos.forEach(item => {
          item.nome_servico = item.nome_produto
        })
        if (atendimento.plano_pagamento) {
          commit(SET_STATE, { tabela_plano_pagamento: atendimento.plano_pagamento.tabela })
        }
        dispatch(LOAD_PRODUTOS_UNIDADES, atendimento.unidade_negocio_id)
        dispatch(LOAD_SERVICOS_UNIDADES, atendimento.unidade_negocio_id)
        dispatch('form/BOOTSTRAP_FORM', { model: new Atendimento(atendimento) }, { root: true })
      })
    } else {
      const data_atual = moment().toDate()
      const atendimento_id = data_atual.getFullYear().toString().substr(-2) +
      (data_atual.getMonth() + 1).toString().padStart(2, '0') +
      data_atual.getDate().toString().padStart(2, '0') +
      data_atual.getHours().toString().padStart(2, '0') +
      data_atual.getMinutes().toString().padStart(2, '0') +
      data_atual.getSeconds().toString().padStart(2, '0') +
      data_atual.getMilliseconds().toString().padStart(3, '0')

      const data_atendimento = moment().format('YYYY-MM-DD')

      const newAtendimento = new Atendimento({
        atendimento_id,
        data_atendimento: data_atendimento,
        observacao: '',
        itens: [],
        itens_servicos: [],
      })

      dispatch('form/BOOTSTRAP_FORM', { model: newAtendimento }, { root: true })
    }
    commit(SET_STATE, { loading: false })
  },
  async [LOAD_TECNICOS] ({ commit, state }) {
    try {
      api.listEntidade('tecnico/filtro').then(
        tecnicos => {
          commit(SET_STATE, { tecnicos })
        },
      )
    } catch (error) {
      console.error('Error loading tecnico data:', error)
    }
  },
  async [LOAD_PLANOS_PAGAMENTO] ({ commit, state }) {
    try {
      api.listEntidade('plano-pagamento').then(
        (planos) => {
          commit(SET_STATE, { planos_pagamentos: planos })
        },
      )
    } catch (error) {
      console.error('Error loading plano de pagamento data:', error)
    }
  },
  async [SUBMIT] ({ dispatch, commit, state, rootState }) {
    commit(SET_STATE, { desabilitarBotao: true })
    const form = { ...rootState.form.data }
    const produtor = rootState.produtores.produtores.find(produtor => produtor.id === form.produtor_id)
    const cadastro = produtor.fazendas.find(fazenda => fazenda.id === form.fazenda_id).cadastro
    form.fazenda_produtor_id = cadastro.id
    Swal.fire({
      title: 'Movimentando o Atendimento!',
      showConfirmButton: false,
      timer: 1500,
    })
    Swal.showLoading()
    api.salvarEntidade(form, 'atendimento', form.id).then(response => {
      let data_i = new Date()
      data_i.setMonth(data_i.getMonth() - 3)
      data_i = data_i.toISOString().slice(0, 10)
      const data_f = new Date().toISOString().slice(0, 10)
      this.data_inicial = data_i
      this.data_final = data_f

      dispatch('atendimentos/BOOTSTRAP', { data_inicial: data_i, data_final: data_f }, { root: true })
      commit('CLOSE')
      Swal.hideLoading()
      Swal.update({
        icon: 'success',
        title: 'O Atendimento foi movido com sucesso!',
      })
    }).catch(err => {
      commit(SET_STATE, { desabilitarBotao: false })
      Swal.hideLoading()
      Swal.update({
        icon: 'error',
        title: 'Atenção!',
        text: err.error,
      })
    })
  },

  async [CREATE_ATENDIMENTO] ({ dispatch, commit, state, rootState }) {
    commit(SET_STATE, { desabilitarBotao: true })
    const form = { ...rootState.form.data }
    const produtor = rootState.produtores.produtores.find(produtor => produtor.id === form.produtor_id)
    const cadastro = produtor.fazendas.find(fazenda => fazenda.id === form.fazenda_id).cadastro
    form.fazenda_produtor_id = cadastro.id

    api.cadastrarEntidade(form, 'atendimento').then(response => {
      let data_i = new Date()
      data_i.setMonth(data_i.getMonth() - 3)
      data_i = data_i.toISOString().slice(0, 10)
      const data_f = new Date().toISOString().slice(0, 10)
      this.data_inicial = data_i
      this.data_final = data_f

      dispatch('atendimentos/BOOTSTRAP', { data_inicial: data_i, data_final: data_f }, { root: true })
      commit('CLOSE')
      Swal.fire({
        icon: 'success',
        title: 'O Atendimento foi criado com sucesso!',
        timer: 4000,
      })
    }).catch(err => {
      commit(SET_STATE, { desabilitarBotao: false })
      Swal.fire(
        {
          icon: 'error',
          title: 'Atenção!',
          text: err.error,
        })
    })
  },

  async [LOAD_PRODUTOS] ({ commit }) {
    await api.listEntidade('produto').then((produtos) => {
      commit(SET_STATE, { produtos })
    })
  },
  async [LOAD_SERVICOS] ({ commit }) {
    await api.listEntidade('servico').then((servicos) => {
      commit(SET_STATE, { servicos })
    })
  },

  async [LOAD_PRODUTOS_UNIDADES] ({ commit }, unidade) {
    await api.getEntidade('catalogo/produtos', unidade).then((produtosUnidades) => {
      commit(SET_STATE, { produtosUnidades: produtosUnidades.data })
    })
  },

  async [LOAD_SERVICOS_UNIDADES] ({ commit }, unidade) {
    await api.getEntidade('catalogo/servicos', unidade).then((servicosUnidades) => {
      commit(SET_STATE, { servicosUnidades: servicosUnidades.data })
    })
  },

  async [LOAD_CATEGORIES] ({ commit }) {
    await api.listEntidade('categoria/produto').then((categories) => {
      commit(SET_STATE, { categories })
    })
  },

  async [LOAD_UNIDADES] ({ commit }) {
    await api.listEntidade('unidade').then((unidades) => {
      commit(SET_STATE, { unidades })
    })
  },

  async [LOAD_PRODUTOS_FROM_CATEGORY] ({ commit }, category) {
    await api.listEntidade(`categoria/${category}`).then((produtos) => {
      commit(SET_STATE, { produtos })
    })
  },

  async [PUSH_ITEM] ({ commit, state, rootState }, item) {
    commit(SET_STATE, { loading: true, dialog: true })
    const form = { ...rootState.form.data }
    form.itens.push({
      ...item,
      id: uuid(),
    })
    commit('form/SET_STATE', { data: form }, { root: true })
    commit(SET_STATE, { loading: false })
  },

  async [PUSH_ITEM_SERVICO] ({ commit, state, rootState }, item) {
    commit(SET_STATE, { loading: true, dialog: true })
    const form = { ...rootState.form.data }
    form.itens_servicos.push({
      ...item,
      id: uuid(),
    })
    commit('form/SET_STATE', { data: form }, { root: true })
    commit(SET_STATE, { loading: false })
  },

  async [DELETE_ITEM] ({ commit, state, rootState }, item) {
    commit(SET_STATE, { dialog: true })
    const form = { ...rootState.form.data }

    return await Swal.fire({
      title: 'Excluir',
      text: 'Tem certeza que deseja excluir o item da cotação?',
      icon: 'question',
      showCancelButton: true,
      showLoaderOnConfirm: true,
      confirmButtonColor: '#109010',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Excluir',
      cancelButtonText: 'Cancelar',
      reverseButtons: true,
      focusConfirm: false,
      preConfirm: () => {
        if (!item.id) {
          commit(SET_STATE, { loading: false })
        }
      },
    }).then((result) => {
      if (result.isConfirmed) {
        const index = form.itens.findIndex((element) => {
          return element.id === item.id || (item.tmp_id && element.tmp_id === item.tmp_id)
        })
        if (index !== -1) {
          form.itens.splice(index, 1)
        }
      }
    })
  },
  async [DELETE_ITEM_SERVICO] ({ commit, state, rootState }, item) {
    commit(SET_STATE, { dialog: true })
    const form = { ...rootState.form.data }

    return await Swal.fire({
      title: 'Excluir',
      text: 'Tem certeza que deseja excluir o serviço da cotação?',
      icon: 'question',
      showCancelButton: true,
      showLoaderOnConfirm: true,
      confirmButtonColor: '#109010',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Excluir',
      cancelButtonText: 'Cancelar',
      reverseButtons: true,
      focusConfirm: false,
      preConfirm: () => {
        if (!item.id) {
          commit(SET_STATE, { loading: false })
        }
      },
    }).then((result) => {
      if (result.isConfirmed) {
        const index = form.itens_servicos.findIndex((element) => {
          return element.id === item.id || (item.tmp_id && element.tmp_id === item.tmp_id)
        })
        if (index !== -1) {
          form.itens_servicos.splice(index, 1)
        }
      }
    })
  },

  async [DELETE_SUBMIT] ({ dispatch, commit, state, rootState }) {
    const form = { ...rootState.form.data }

    return Swal.fire({
      title: 'Excluir',
      text: 'Tem certeza que realmente deseja excluir está cotação?',
      icon: 'question',
      showCancelButton: true,
      showLoaderOnConfirm: true,
      confirmButtonColor: '#109010',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Excluir',
      cancelButtonText: 'Cancelar',
      reverseButtons: true,
      focusConfirm: false,
      preConfirm: () => {
        return api.inativarEntidade('cotacao', form.id).then(
          result => result,
          () => {
            window.Toast.fire('Ocorreu algum erro na exclusão do Atendimento!', '', 'error')
          },
        ).catch(() => {
          window.Toast.fire('Ocorreu algum erro na exclusão do Atendimento!', '', 'error')
        })
      },
    }).then((result) => {
      if (result.isConfirmed) {
        window.Toast.fire('A cotação foi excluída com sucesso!', '', 'success')
        dispatch('atendimentos/BOOTSTRAP', { data_inicial: 'from', data_final: 'to' }, { root: true })
        commit('CLOSE')
      }
    })
  },
  async [LOAD_SETOR_TECNICO] ({ commit }, id) {
    const response = await api.getEntidade('tecnico/setoresTecnico/list', id)
    commit(SET_STATE, { setores_tecnico: response.data })
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
}
